export default __webpack_public_path__ + "static/media/Armbands of the Strange Beyond.ace24e73.jpg";